import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { redirect } from 'redux-first-router';

import {
  ACTION_REQUEST_RESET_PASSWORD,
  REQUEST_RESET_PASSWORD_FAILURE,
  REQUEST_RESET_PASSWORD_SUCCESS,
  resetPasswordAPI,
} from '.';
import { showToastAlert } from '../app';
import { ROUTE_LOGIN } from '../routing';
import { getErrorMessage } from '../../../utils/error';

function* resetPassword() {
  yield takeLatest([ACTION_REQUEST_RESET_PASSWORD], function* (action) {
    yield put(resetPasswordAPI(action.payload));
  });

  yield takeLatest([REQUEST_RESET_PASSWORD_SUCCESS], function* () {
    yield put(
      redirect({
        type: ROUTE_LOGIN,
      })
    );
    yield put(showToastAlert('Reset password successfully!', 'success'));
  });

  yield takeLatest([REQUEST_RESET_PASSWORD_FAILURE], function* (action) {
    yield put(
      showToastAlert(getErrorMessage(action?.payload) || 'Failed to reset password!', 'error')
    );
  });
}

export default function* loadResetPassword() {
  yield all([fork(resetPassword)]);
}
